const statusLabelStrings = {
  partialApprovalStatusText: "Til godkjenning hos {0}. Godkjent av {1}",
  partialPaymentStatusText: "Til betaling hos {0}. Betalt av {1}",
  returnedStatusText: "Sendt i retur av {0}",
  draft: "Kladd lagret"
};

export default statusLabelStrings;